var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.card
    ? _c(
        "v-card",
        { staticClass: "background elevation-0 darken-1" },
        [
          _c(
            "v-card-title",
            { staticClass: "pa-2 title" },
            [
              _vm.is_child
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 mr-3",
                      attrs: { flat: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.card.label) + " [" + _vm._s(_vm.card.id) + "]"
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "background darken-1 pa-0" }, [
            _c(
              "div",
              { attrs: { color: "background darken-1", "icons-and-text": "" } },
              [
                _c(
                  "div",
                  [
                    _c(
                      "v-card",
                      {
                        staticClass: "background darken-1",
                        attrs: { flat: "" }
                      },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-layout",
                              {
                                attrs: {
                                  row: "",
                                  wrap: "",
                                  "justify-center": ""
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { staticClass: "pr-0", attrs: { xs6: "" } },
                                  [
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "title primary--text pb-3 pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.card.subtype_text
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td")
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("ID")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(_vm.card.id))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Creation Date")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  _vm.card.creation_date
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Last Update")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  _vm.card.last_update
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Title Language")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm.card.title_language)
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Episode Num")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(_vm.card.episode_num))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Duration")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm.card.data.duration)
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Production Year")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.card.data.production_year
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Type")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(_vm.card.data.type))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Genre")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(_vm.card.data.genre))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Target")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(_vm.card.data.target))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "pl-1 pr-1",
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              }
                                            },
                                            [_vm._v("Synopsis")]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm.card.data.synopsis)
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _vm.card.data.casting !== undefined &&
                                        _vm.card.data.casting.length > 0
                                          ? _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "pl-1 pr-1",
                                                  staticStyle: {
                                                    "white-space": "nowrap"
                                                  }
                                                },
                                                [_vm._v("Casting")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "pa-0" },
                                                [
                                                  _c(
                                                    "table",
                                                    _vm._l(
                                                      _vm.card.data.casting,
                                                      function(cast, i) {
                                                        return _c(
                                                          "tr",
                                                          { key: "cast" + i },
                                                          [
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "pr-1",
                                                                staticStyle: {
                                                                  "white-space":
                                                                    "nowrap"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    cast.role
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  cast.name
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { staticClass: "pl-0", attrs: { xs6: "" } },
                                  [
                                    _c("table", [
                                      _c(
                                        "tbody",
                                        [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "title primary--text pb-3",
                                                attrs: { colspan: "2" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tLocalized Info\n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.card.data.localized_info,
                                            function(locale, i) {
                                              return _c(
                                                "tr",
                                                { key: "locale" + i },
                                                [
                                                  _c(
                                                    "th",
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                          attrs: {
                                                            label: "",
                                                            color:
                                                              "primary color--text"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                locale.language
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    { staticClass: "pa-0" },
                                                    [
                                                      _c("table", [
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Language")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.language
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Title")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.title
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "pr-1",
                                                              staticStyle: {
                                                                "white-space":
                                                                  "nowrap"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Origin Country"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.origin_country
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Target")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.target
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Synopsis")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.synopsis
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Genre")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.genre
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("th", [
                                                            _vm._v("Type")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                locale.type
                                                              )
                                                            )
                                                          ])
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-divider", { staticClass: "primary" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pa-2" },
                              [
                                _c("tree-view", {
                                  attrs: {
                                    data: _vm.card,
                                    options: {
                                      maxDepth: 0,
                                      rootObjectKey: "Données Brutes"
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abad6202", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abad6202","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/babel_card_view.vue
// module id = null
// module chunks = 